import PropTypes from 'prop-types';

export const ProductModalDefaultProps = {
  brand: {},
  className: '',
  details: [],
  image: {},
  isOpen: false,
  manufacturer_sku: '',
  name: '',
  price_and_stock: {},
  range: '',
  sale_unit: '',
  sku: '',
};

export const ProductModalPropTypes = {
  brand: PropTypes.shape({ name: PropTypes.string }),
  className: PropTypes.string,
  details: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        label: PropTypes.string,
        unit: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  image: PropTypes.shape({ alt: PropTypes.string, url: PropTypes.string }),
  isOpen: PropTypes.bool,
  manufacturer_sku: PropTypes.string,
  name: PropTypes.string,
  price_and_stock: PropTypes.shape({
    has_price: PropTypes.bool,
    has_stock: PropTypes.bool,
    invoice_unit: PropTypes.string,
    price: PropTypes.shape({
      customer_price: PropTypes.number,
      discount_classes: PropTypes.arrayOf(
        PropTypes.shape({}),
        PropTypes.number,
      ),
      discount_price: PropTypes.number,
      public_price: PropTypes.number,
      invoice: PropTypes.shape({
        customer_price: PropTypes.number,
        discount_price: PropTypes.number,
        public_price: PropTypes.number,
        unit: PropTypes.string,
        weee_amount: PropTypes.number,
      }),
      sale: PropTypes.shape({
        customer_price: PropTypes.number,
        discount_price: PropTypes.number,
        public_price: PropTypes.number,
        unit: PropTypes.string,
        weee_amount: PropTypes.number,
      }),
      tier_prices: PropTypes.arrayOf(PropTypes.shape({})),
      weee_amount: PropTypes.number,
    }),
    sale_unit: PropTypes.string,
    stock_status: PropTypes.string,
    stocks: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  range: PropTypes.string,
  sale_unit: PropTypes.string,
  sku: PropTypes.string,
};
